import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { t } from 'i18next';
import { GET_ORDER } from 'src/apiService/apiDeclaration';
import usePagination from 'src/hooks/usePagination';
import { orderTableColumns } from 'src/constants/columnConfig';
import { useModal } from 'src/hooks/useModal';

const columnCommonConfig = { sortable: false, width: 150 };

const CustomerOrdersModal = ({ customerId }) => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const { handleModalClose } = useModal();

  const { paginationModel, setPaginationModel, loading, data } = usePagination(GET_ORDER, {
    customerId,
    status: '',
    search: '',
  });

  const columns = [
    ...orderTableColumns,
    {
      field: 'totalAmount',
      headerName: 'common.totalAmount',
      ...columnCommonConfig,
      renderCell: ({ row }) => (row.totalAmount ? row.totalAmount : '-'),
      flex: 1,
    },
  ].map((col) => ({
    ...col,
    headerName: typeof col.headerName === 'string' ? translate(col.headerName) : col.headerName,
  }));

  const handleRowClick = useCallback(
    (row) => {
      handleModalClose();
      navigate('/order-details', { state: row });
    },
    [navigate, handleModalClose]
  );

  const handleCellClick = (params) => {
    if (params.field !== 'action') {
      handleRowClick(params.row);
    }
  };

  const slots = {
    noRowsOverlay: () => (
      <Box width="100%" display="flex" justifyContent="center" alignItems="center" height="100%" py={4}>
        <Typography variant="body2">{t('labels.noRecords') || 'No records found'}</Typography>
      </Box>
    ),
  };

  return (
    <Box
      sx={{
        minWidth: { xs: '100%', sm: 500 },
      }}
    >
      <DataGrid
        rows={data.rows}
        columns={columns}
        getRowId={(row) => row._id || row.date}
        onCellClick={handleCellClick}
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        pagination
        paginationMode="server"
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        rowCount={data.rowCount}
        pageSizeOptions={[10]}
        loading={loading}
        slots={slots}
        sx={{
          minHeight: 200,
          backgroundColor: 'white',
          '& .MuiDataGrid-cell': {
            cursor: 'pointer',
          },
        }}
      />
    </Box>
  );
};

export default CustomerOrdersModal;
